<template>
  <div class="cloud-page">
    <div v-if="isWeixin">
      <p>点击以下按钮打开 “HiPC小程序”</p>
      <wx-open-launch-weapp username="gh_c070b0d08936" path="/newPages/pages/bookmark/index/index">
        <script type="text/wxtag-template">
          <style>
          .btn-click {
            width: 200px;
            height: 45px;
            text-align: center;
            font-size: 17px;
            display: block;
            margin: 100px auto 0;
            padding: 8px 24px;
            border: none;
            border-radius: 4px;
            background-color: #07c160;
            color:#fff;
          }
        </style>
        <button class="btn-click">打开小程序</button>
        </script>
      </wx-open-launch-weapp>
    </div>
    <template v-else-if="isMobile">
      <p>正在打开 “HiPC小程序”...</p>
      <button @click="openWeapp()" class="btn_click">打开小程序</button>
    </template>
    <template v-else-if="isDesktop">
      <p>请在手机打开网页链接</p>
    </template>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
const { initCloud } = require('@wxcloud/cloud-sdk')
const cloud = initCloud()

export default {
  name: "CloudLink",
  data() {
    return {
      isWeixin: false,
      isDesktop: false,
      isMobile: false,
      c: null,
    };
  },
  created() {

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      this.docReady()
    } else {
      document.addEventListener('DOMContentLoaded', this.docReady());
    }
  },
  methods: {
    initWxConfig() {
      wx.config({
        // debug: true, // 调试时可开启
        appId: 'wx6265a35adb332603',
        timestamp: 0, // 必填，填任意数字即可
        nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
        signature: 'signature', // 必填，填任意非空字符串即可
        jsApiList: ['chooseImage'], // 安卓上必填一个，随机即可
        openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      })
    },
    async docReady(){
      const ua = navigator.userAgent.toLowerCase();
      const isWXWork = ua.match(/wxwork/i) == 'wxwork';
      const mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)
      if (!isWXWork && ua.match(/MicroMessenger/i) == 'micromessenger' && mobile) {
        this.initWxConfig()
        this.isWeixin = true
      } else if (mobile) {
        this.isMobile = true
        this.c = new cloud.Cloud({
          // 必填，表示是未登录模式
          identityless: true,
          // 资源方 AppID
          resourceAppid: 'wx6265a35adb332603',
          // 资源方环境 ID
          resourceEnv: 'hipc-1g1hfqfseeb4fce2',
        })
        await this.c.init()
        try {
          await this.openWeapp()
        } catch (e) {
          throw e
        }
      } else {
        this.isDesktop = true
      }
    },
    async openWeapp(onBeforeJump) {
      const res = await this.c.callFunction({
        name: 'public',
        data: {
          action: 'getUrlScheme',
        },
      })
      if (onBeforeJump) {
        onBeforeJump()
      }
      location.href = res.result.openlink
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped>
.cloud-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.btn_click {
  width: 200px;
  height: 45px;
  text-align: center;
  font-size: 17px;
  display: block;
  margin: 100px auto 0;
  padding: 8px 24px;
  border: none;
  border-radius: 4px;
  background-color: #07c160;
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/view/hipc/CloudLink.vue